import { axios } from "../../util/axiosConfig";
import { incidents } from "../urls";

const getUserIncidents = () =>
  axios
    .get(incidents.search, { params: { scope: "2", heartFilter: false, status: "1,2,3,4" } })
    .then(response => response.data?.results?.filter(i => i.author));

export default getUserIncidents;
